module.exports = __webpack_public_path__ + "img/Logo-01_cor.f090db13.png";